import styled from "styled-components";

export const Body = styled.div`
  padding: 0px 24px;
`